import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const DATA_GRID_MAX_HEIGHT = 620;
export const DATA_GRID_ROW_HEIGHT = 52;
export const DATA_GRID_HEADER_HEIGHT = 56;
export const DATA_GRID_FOOTER_HEIGHT = 56;

/** Altura da grade: cabe no conteúdo, com teto para ativar scroll interno. */
export function dataGridHeight(
  visibleRowCount: number,
  {
    rowHeight = DATA_GRID_ROW_HEIGHT,
    maxHeight = DATA_GRID_MAX_HEIGHT,
    emptyBodyHeight = 120
  }: {
    rowHeight?: number;
    maxHeight?: number;
    emptyBodyHeight?: number;
  } = {}
): number {
  const body =
    visibleRowCount > 0 ? visibleRowCount * rowHeight : emptyBodyHeight;
  return Math.min(
    DATA_GRID_HEADER_HEIGHT + body + DATA_GRID_FOOTER_HEIGHT,
    maxHeight
  );
}

/** Quantidade de linhas visíveis na página atual da paginação. */
export function visibleDataGridRows(
  totalRows: number,
  page: number,
  pageSize: number
): number {
  if (totalRows <= 0 || pageSize <= 0) return 0;
  const start = page * pageSize;
  if (start >= totalRows) return 0;
  return Math.min(pageSize, totalRows - start);
}

export function DataGridFrame({
  children,
  visibleRowCount,
  rowHeight,
  maxHeight,
  className
}: {
  children: ReactNode;
  visibleRowCount: number;
  rowHeight?: number;
  maxHeight?: number;
  className?: string;
}) {
  return (
    <div
      className={twMerge('ds-data-grid w-full', className)}
      style={{ height: dataGridHeight(visibleRowCount, { rowHeight, maxHeight }) }}
    >
      {children}
    </div>
  );
}
